var map = {
	"./avispace/app/forbidden/forbidden.component": [
		6148,
		[
			"src_themes_avispace_app_forbidden_forbidden_component_ts"
		]
	],
	"./custom/app/forbidden/forbidden.component": [
		203,
		[
			"src_themes_custom_app_forbidden_forbidden_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 30130;
module.exports = webpackAsyncContext;